import styled from '@emotion/styled'

export const BadgeWithLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`
